// Outlook-agenda van de ingelogde gebruiker (delegated Calendars.Read) — voor de
// Vandaag-pagina: afspraken tonen die (nog) geen Airtable-taak hebben, zodat de
// dag altijd compleet is, ongeacht wat de Outlook→Airtable-sync oppakt.
import { acquireGraphToken } from "./graphToken";
import { nlTijdstipIso } from "./nlDatum";

const GRAPH = "https://graph.microsoft.com/v1.0";

/**
 * Alle agenda-items van één dag (YYYY-MM-DD), NL-tijden.
 * Returnt [{ id, subject, start, end, isAllDay, showAs }] — start/end als ISO
 * mét tijdzone-offset zodat new Date() ze correct leest.
 */
export async function fetchDayEvents(dateStr) {
  const token = await acquireGraphToken(["Calendars.Read"]);
  // Mét NL-offset: zonder offset leest Graph UTC (02:00–01:59 NL); de Prefer-header
  // stuurt alleen de uitvoer.
  const van = encodeURIComponent(nlTijdstipIso(dateStr, "00:00:00"));
  const tot = encodeURIComponent(nlTijdstipIso(dateStr, "23:59:59"));
  const url = `${GRAPH}/me/calendarView?startDateTime=${van}&endDateTime=${tot}` +
    `&$select=subject,start,end,isAllDay,isCancelled,showAs,webLink&$orderby=start/dateTime&$top=50`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}`, Prefer: 'outlook.timezone="W. Europe Standard Time"' },
  });
  if (!res.ok) throw new Error(`Agenda ophalen mislukt (${res.status})`);
  const items = (await res.json()).value || [];
  return items
    .filter((ev) => !ev.isAllDay && !ev.isCancelled)
    .map((ev) => ({
      id: ev.id,
      subject: ev.subject || "(geen onderwerp)",
      // Graph geeft "2026-07-07T14:00:00.0000000" in de gevraagde tijdzone,
      // zonder offset — zo laten en alleen HH:MM eruit lezen (geen tz-gok).
      start: ev.start?.dateTime || "",
      end: ev.end?.dateTime || "",
      showAs: ev.showAs || "busy",
      webLink: ev.webLink || null,
    }));
}
